import { render, staticRenderFns } from "./SurvivorBestBuild.vue?vue&type=template&id=76e4ee19&scoped=true&"
import script from "./SurvivorBestBuild.vue?vue&type=script&lang=js&"
export * from "./SurvivorBestBuild.vue?vue&type=script&lang=js&"
import style0 from "./SurvivorBestBuild.vue?vue&type=style&index=0&id=76e4ee19&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e4ee19",
  null
  
)

export default component.exports